import { render, staticRenderFns } from "./GeneratorDetailPage.vue?vue&type=template&id=01c1077a&scoped=true"
import script from "./GeneratorDetailPage.vue?vue&type=script&lang=js"
export * from "./GeneratorDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1077a",
  null
  
)

export default component.exports